/**
 * This temporary hardcode needs for displaying country flags in select.
 * It could be deleted if backend returns countryCode.
 */
export const currencyCodes = {
  AUD: 'AU',
  CAD: 'CA',
  CNY: 'CN',
  EUR: 'EU',
  GBP: 'GB',
  JPY: 'JP',
  USD: 'US',
};

// Used in finsight ourSolutions page
// 'savings-guarantee' corresponds to savingsGuaranteeHash constant in faqCollection
export const savingsGuaranteeFootnoteUrl = '/pricing#savings-guarantee';
